import React from "react";

const updates = [];

const UpdatesPage = () => {
  return (
    <div className="mx-auto max-w-4xl py-10">
      <header className="mb-8">
        <p className="text-sm font-bold uppercase text-sky-500 dark:text-sky-400">Mises à jour</p>
        <h1 className="mt-2 text-3xl font-black text-slate-950 dark:text-white">Historique</h1>
      </header>

      <section className="rounded-2xl border border-sky-500/10 bg-white/85 p-6 shadow-xl shadow-slate-950/5 backdrop-blur dark:bg-slate-950/70">
        {updates.length === 0 ? (
          <p className="text-sm font-semibold text-slate-600 dark:text-slate-300">
            Aucune mise à jour renseignée pour le moment.
          </p>
        ) : (
          updates.map((update) => (
            <article key={update.version} className="border-b border-sky-500/10 py-5 last:border-b-0">
              <h2 className="text-xl font-black text-slate-950 dark:text-white">{update.title}</h2>
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                Version {update.version} - {update.date}
              </p>
            </article>
          ))
        )}
      </section>
    </div>
  );
};

export default UpdatesPage;
